import React from 'react';
import styled, { css } from 'react-emotion';
import { Query } from 'react-apollo';
import theme from '@jetshop/ui/utils/theme';
import productRowQuery from '../Shortcodes/ProductRowQuery.gql';
import { ProductGrid } from '../CategoryPage/ProductGrid';
import { NewProductCard } from '../CategoryPage/NewProductCard';
import { Price } from '../Price';

const Wrapper = styled('div')`
  width: 100%;
  max-width: 1280px;
  padding: 1rem 2rem;
  margin: 1rem auto;
  ${({ theme }) => theme.below.lg} {
    padding: 0;
    margin: 0 0 1rem 0;
    &.small-products {
      padding: 10px 0;
      margin: 0;
    }
  }
  .product-grid {
    width: 100%;
    ${({ theme }) => theme.below.lg} {
      margin: 0;
    }
  }
  &.small-products {
    h2 {
      font-size: 1rem;
    }
  }
  &.mobile-styling {
    padding: 0;
    h2 {
      font-size: 14px;
    }
  }
  h2 {
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: 1.5rem;
    margin-bottom: 20px;
    text-align: center;
    line-height: 1;
    font-weight: bold;
    letter-spacing: 1px;
    margin-top: 20px;
  }
`;

const ProductGridWrapper = styled('ul')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;

  ${Price.Wrapper} {
    display: flex;
  }
  ${Price.New} {
    color: ${theme('colors.red')};
    margin-right: 8px;
  }
  ${Price.Old} {
    color: ${theme('colors.grey')};
  }
  .product-card {
    line-height: 19px;
    /* 
       * For browsers that do not support grid, we need to specify the width of
       * each product
       */
    width: 50%;
    ${({ theme }) => theme.above.md} {
      width: 33.333%;
    }
    ${({ theme }) => theme.above.lg} {
      width: 25%;
    }
    a {
      margin: 0 0.5em 2em 0.5em;
    }
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 1em;
    grid-row-gap: 2em;
    margin-bottom: 2em;
    .product-card {
      width: 100%;
      a {
        margin: 0;
      }
    }

    ${({ theme }) => theme.below.lg} {
      grid-template-columns: repeat(3, 1fr);
    }

    ${({ theme }) => theme.below.md} {
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 10px;
      grid-column-gap: 5px;
    }
  }
`;

export const DepictProductsGrid = ({
  products,
  title,
  smallProducts,
  mobileStyling,
  productObject,
  onClickCallback
}) => {
  if (!products?.length > 0) return null;

  return (
    <Query
      variables={products && { articleNumbers: products }}
      query={productRowQuery}
      ssr={true}
      errorPolicy={'ignore'}
    >
      {({ loading, error, data }) => {
        if (loading || error) return null;
        if (data && !data.products.length) return null;
        if (!data?.products?.length > 0) return null;

        return (
          <Wrapper
            className={`${smallProducts && 'small-products'} ${mobileStyling &&
              'mobile-styling'}`}
          >
            {title ? <h2>{title}</h2> : null}

            <ProductGridWrapper
              className={`${smallProducts &&
                'small-products'} ${mobileStyling && 'mobile-styling'}`}
            >
              {data?.products?.map((product, i) => {
                const variants = product?.variants?.values;
                const recommendation_id = productObject?.filter(depictProd =>
                  variants?.find(
                    variant =>
                      variant?.articleNumber === depictProd.articleNumber
                  )
                );
                return (
                  <NewProductCard
                    key={i}
                    product={product}
                    groupedProducts={[]}
                    recommendation_id={recommendation_id}
                    onClickCallback={onClickCallback}
                  />
                );
              })}
            </ProductGridWrapper>
          </Wrapper>
        );
      }}
    </Query>
  );
};
